import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import api from '../utils/api';

/**
 * PublicFooter Component
 * Shared footer for all public pages (Login, Register, Admin, Landing)
 * Fetches site settings from CMS for logo and branding
 */
const PublicFooter = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/cms/public/site-settings');
        const processedSettings = { ...response.data };
        const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
        
        // Convert relative URLs to absolute URLs
        if (processedSettings.logo_url && processedSettings.logo_url.startsWith('/api')) {
          processedSettings.logo_url = `${backendUrl}${processedSettings.logo_url}`;
        }
        
        setSettings(processedSettings);
      } catch (error) {
        console.error('Failed to fetch site settings:', error);
      }
    };
    
    fetchSettings();
  }, []);

  const siteName = settings?.site_name || 'OnTrOf';

  return (
    <footer className="border-t border-slate-700/50 py-6 bg-slate-900/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            {settings?.logo_url ? (
              <img src={settings.logo_url} alt={siteName} className="h-8 w-auto" />
            ) : (
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-lg flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
            )}
            <span className="text-white font-semibold">{siteName}</span>
          </Link>

          {/* Copyright */}
          <div className="text-slate-400 text-sm">
            {settings?.copyright_text || `© ${new Date().getFullYear()} OnTrOf Technologies. All rights reserved.`}
          </div>

          {/* Footer Links */}
          <div className="flex gap-6">
            <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">Privacy</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">Terms</Link>
            <Link to="/#contact" className="text-slate-400 hover:text-white text-sm transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
